import { getIdleTimeoutSeconds } from '@/utils/appConfig'

const sessionInactivity = {
  namespaced: true,

  state: () => ({
    activeUserEvents: ['mousemove', 'click', 'scroll', 'keydown'],
    isUserInactive: false,
    sessionTime: getIdleTimeoutSeconds()
  }),

  getters: {
    _isUserInactive: state => state.isUserInactive,
    _sessionTime: state => state.sessionTime
  },

  mutations: {
    IS_USER_INACTIVE (state, data) {
      state.isUserInactive = data
    },
    SESSION_TIME (state, data) {
      state.sessionTime = data
    },
    DECREMENT_TIME (state, t) {
      state.sessionTime -= t
    }
  },

  actions: {
    StartSessionTimer ({ state, commit, dispatch }, configHeader) {
      const resetTimer = () => commit('SESSION_TIME', getIdleTimeoutSeconds())

      const sessionInterval = setInterval(checkCountDownTimer, 60000) // 1 minute

      // checks for user activity
      state.activeUserEvents.forEach((event) => document.addEventListener(event, resetTimer, true))

      function checkCountDownTimer () {
        if (state.sessionTime === 0) {
          // stops check for user activity
          state.activeUserEvents.forEach((event) => document.removeEventListener(event, resetTimer, true))

          // stop interval
          clearInterval(sessionInterval)

          dispatch('users/Logout', configHeader, { root: true })
            .finally(() => {
              // show timeout modal
              commit('IS_USER_INACTIVE', true)
            })

          return
        }

        commit('DECREMENT_TIME', 60) // decrement timer by 60 seconds
      }
    }
  }
}

export default sessionInactivity
